import axios from "axios";
import MD5 from "md5";

export const joinWebinar = async (email, scheduleId) => {
    await axios
      .post(process.env.REACT_APP_FETCH_URL + `/schedule/${scheduleId}/join`, {
        participantId: MD5(new Date().getTime()),
        email: email,
        scheduleId: scheduleId
      })
      .then((res) => {
      })
      .catch((err) => {
      });
}